import {FormError} from "@/components/ui/forms/FormError";

import {useEffect, useState} from "react";

import {ControlButton} from "@ui/buttons/ControlButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {Spinner} from "@ui/general/Spinner";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const DeleteDataPopup = (props) => {
  const {
    onClickYes,
    onClickYesFull,
    onClickNo,
    btnYes,
    btnYesFull,
    btnNo,
    title,
    desc,
    getDesc,
  } = props;
  const {t} = useTranslation();
  const {attached_scenarios} = useSelector((state) => state.product.view);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  const handleClickYes = async () => {
    try {
      setStatus("loading");
      setError("");

      const result = await onClickYes();

      if (typeof result === "string" && result) {
        setError(result);
      }
    } catch (e) {
      console.log('Error click "YES": ', e);
      setError(t("popup.delete_data.error_generic"));
    } finally {
      setStatus("");
    }
  };

  const handleClickYesFull = async () => {
    try {
      setStatus("loading");
      setError("");

      const result = await onClickYesFull();

      if (typeof result === "string" && result) {
        setError(result);
      }
    } catch (e) {
      console.log('Error click "YES FULL": ', e);
      setError(t("popup.delete_data.error_generic"));
    } finally {
      setStatus("");
    }
  };

  useEffect(() => {
    if (desc && getDesc) {
      getDesc();
    }
  }, [desc, getDesc]);

  return (
    <div className={styles.deletePopup}>
      {status === "loading" && (
        <Spinner
          width={40}
          height={40}
        />
      )}

      <h2>{title || t("popup.delete_data.subtitle")}</h2>

      {error && (
        <FormError
          error={error}
          bottom={10}
          center
        />
      )}

      {desc && attached_scenarios && attached_scenarios.length > 0 && (
        <RootDesc>
          <span>
            {desc} <br /> ({attached_scenarios.join(", ")})
          </span>
        </RootDesc>
      )}

      <div className={styles.buttons}>
        {btnYesFull && attached_scenarios && attached_scenarios.length && (
          <div className={styles.buttonYesFull}>
            <ControlButton
              color={"var(--red)"}
              txt={t("button.yes_full")}
              onClick={() => handleClickYesFull()}
            />
          </div>
        )}

        <div className={styles.buttonYes}>
          <ControlButton
            color={"var(--red)"}
            txt={btnYes || t("button.yes")}
            onClick={() => handleClickYes()}
          />
        </div>

        <div className={styles.buttonNo}>
          <ControlButton
            color={"var(--green)"}
            txt={btnNo || t("button.no")}
            onClick={() => onClickNo()}
          />
        </div>
      </div>
    </div>
  );
};
